import {Component, OnInit, ViewChild} from '@angular/core';
import {ResumeService} from '../../../services/resume.service';
import {Resume} from './models/Resume';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {Router} from '@angular/router';
import {MatTabGroup} from "@angular/material/tabs";

@Component({
  selector: 'app-resumes',
  templateUrl: './resumes.component.html',
  styleUrls: ['./resumes.component.scss']
})
export class ResumesComponent implements OnInit {
  resumes: Resume[];
  @ViewChild('tabs', {static: true}) tabs: MatTabGroup;
  constructor(private resumeService: ResumeService,
              public router: Router,
              private toastService: ToastMessagesService) { }

  async ngOnInit(): Promise<void> {
   this.tabs.selectedIndex = 1;
  }




  async fetchResumes(): Promise<Resume[]> {
    try {
      return await this.resumeService.fetchResumes();
    } catch (e) {
      this.toastService.toastErrorMessage(e.message);
    }
  }

  async reload(event) {
    await this.fetchResumes();
  }

  async navigateToResumeCreator(): Promise<void> {
    await this.router.navigate(['/home/resume-creator'], {queryParams: {mode: 'create'}});
  }
}
